﻿import { Routes, Route, Navigate } from 'react-router'
import { MainLayout } from './layouts/MainLayout'
import { Toaster } from '@/components/ui/toaster'
import { DesktopPage } from './pages/DesktopPage'
import { LoginPage } from './pages/LoginPage'
import { PublicActivityPage } from './pages/PublicActivityPage'
import { DocumentLinkPage } from './pages/DocumentLinkPage'
import { SharedFilePage } from './pages/SharedFilePage'
import { StandaloneLayout } from './layouts/StandaloneLayout'
import { StandaloneChatPage } from './pages/StandaloneChatPage'
import { StandaloneDrivePage } from './pages/StandaloneDrivePage'
import { StandaloneSettingsPage } from './pages/StandaloneSettingsPage'
import { StandaloneTicketsPage } from './pages/StandaloneTicketsPage'
import { StandaloneHarnessPage } from './pages/StandaloneHarnessPage'
import { ProtectedRoute } from './components/auth/ProtectedRoute'
import { RequireApplication } from './components/auth/RequireApplication'

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        {/* Azure AD callback - renders LoginPage which handles MSAL redirect */}
        <Route path="/auth/callback" element={<LoginPage />} />
        {/* Public auth-free route for public_link activities (#328). Must
            sit OUTSIDE ProtectedRoute so anonymous respondents can access
            surveys via the token-based link. */}
        <Route path="/activity/:token" element={<PublicActivityPage />} />
        <Route element={<ProtectedRoute />}>
          {/* Geteilter Dokument-Link (#516). Bewusst ausserhalb beider
              RequireApplication-Gates: welcher Wirt das Dokument zeigt,
              entscheidet die Seite selbst anhand der Zuweisungen des
              EMPFAENGERS. Ein Gate davor wiese einen Teil der Empfaenger
              ab, bevor die Frage gestellt ist. */}
          <Route path="/d/:documentId" element={<DocumentLinkPage />} />
          {/* Geteilter Datei-Link (#598). Ebenfalls ausserhalb der Gates,
              hier aber aus einem staerkeren Grund als bei /d/ darueber:
              Diese Route leitet nirgendwohin weiter, sie ZEIGT die Datei.
              Sie traegt damit auch fuer Empfaenger, denen ueberhaupt keine
              Anwendung zugewiesen ist. Der Link gewaehrt Einsicht, keine
              Kopie — es wird nichts in das Drive des Empfaengers
              geschrieben. */}
          <Route path="/f/:token" element={<SharedFilePage />} />
          {/* Standalone apps (#504). Deliberately OUTSIDE MainLayout: the
              same apps as the desktop windows, but without the shell — no
              window manager, no taskbar, no Cortex. StandaloneLayout owns
              the icon rail (app switch, desktop, logout) and the host. */}
          {/* Die shell-freien Routen sind an PDB geknüpft — sie lösen
              cdb-pdb ab, also gilt dort dessen Zuweisung, nicht die des
              Desktops. */}
          <Route element={<RequireApplication app="pdb" />}>
            <Route element={<StandaloneLayout />}>
              <Route path="/chat" element={<StandaloneChatPage />} />
              <Route path="/drive" element={<StandaloneDrivePage />} />
              <Route path="/settings" element={<StandaloneSettingsPage />} />
              {/* "Meine Tickets" (#1169): the reporter view of Cortex for
                  users without a desktop; target of their ticket notifications. */}
              <Route path="/tickets" element={<StandaloneTicketsPage />} />
              {/* cdbHARNESS prototype v0 (#1366): admins only, checked inside the app. */}
              <Route path="/harness" element={<StandaloneHarnessPage />} />
            </Route>
          </Route>
          <Route element={<RequireApplication app="webos" />}>
            <Route element={<MainLayout />}>
              <Route path="/desktop" element={<DesktopPage />} />
              {/* Add other protected routes here */}
            </Route>
          </Route>
        </Route>
        {/* Catch-all redirects to login for any unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </>
  )
}

export default App
